module.exports = __webpack_public_path__ + "img/5.fe2544f2.jpg";